import { observable, computed } from 'mobx'
import { CreateOrUpdateTransfer, ITransfer } from '@getgreenline/homi-shared'

export class TransferStore {
  @observable
  existingTransfer: ITransfer | null = null

  @observable
  editTransfer: CreateOrUpdateTransfer = new CreateOrUpdateTransfer()

  @observable
  hasUnsavedChanges = false

  @computed
  get isEditable() {
    if (!this.existingTransfer) {
      return true
    } else if (this.existingTransfer.status === 'pending') {
      return true
    } else {
      return false
    }
  }

  // Receive a transfer object from the API
  populate(transfer: ITransfer) {
    this.existingTransfer = transfer
    this.editTransfer.populate(transfer)
    this.hasUnsavedChanges = false
  }

  clear() {
    this.existingTransfer = null
    Object.assign(this.editTransfer, new CreateOrUpdateTransfer())
  }
}
